import { ADMIN_NOTIFICATIONS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const adminNotificationApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAdminNotifications: builder.query({
            query: (params = {}) => ({
                url: ADMIN_NOTIFICATIONS_URL,
                method: 'GET',
                params,
            }),
            providesTags: (result) => {
                const notifications = result?.notifications || [];

                return [
                    { type: 'AdminNotification', id: 'LIST' },
                    ...notifications.map((notification) => ({
                        type: 'AdminNotification',
                        id: notification._id || notification.id,
                    })),
                ];
            },
        }),
        markAdminNotificationsRead: builder.mutation({
            query: (payload) => ({
                url: `${ADMIN_NOTIFICATIONS_URL}/read`,
                method: 'PATCH',
                body: payload,
            }),
            invalidatesTags: [{ type: 'AdminNotification', id: 'LIST' }],
        }),
    }),
});

export const {
    useGetAdminNotificationsQuery,
    useMarkAdminNotificationsReadMutation,
} = adminNotificationApiSlice;

